<template>
    <div class="container" @click="abriuItemVenda">
        <!-- <h4 style="color: green;">{{JSON.stringify(item)}}</h4> -->
        <div :style="{ display: temImagem ? 'block' : 'none'}">
            <img
            :src="item.imagem"
            class="imagens"
            @error="onErrorImagem"
            ref="imagemzinha"
        />            
        </div>

        <!-- dados abaixo da imagem  -->

        <div style="padding: 10px; margin: 0; min-height: 45px; display: flex; flex-direction: column; justify-content: center;  " >
            <div :class="porColunas ? 'titulo-preco-block' : 'titulo-preco'" style=" margin: 0; padding: 0">
                <div class="titulo-preco-nome" >
                    <p style="margin: 0;">{{ this.item.nome }}</p>
                    <!-- <p style="margin: 0;">{{ this.item.tempoEstimado }}</p> -->
                </div>

                <div v-if="item.tipo != 'comboPorTamanho' && item.tipo != 'comboPorEtapa' && item.tipo != 'comboPizza'" class="titulo-preco-preco">

                    <!-- preco normal  -->
                    <p v-if="!temPromocao" style="margin: 0">
                        R$ {{ item.preco.toFixed(2).replace(".", ",") }}
                    </p>

                    <!-- preco PROMO  -->
                    <div v-if="temPromocao">
                        <p v-if="promocaoMenorQueValorNormal"  style="text-decoration: line-through; color: black; font-size: 12px; margin: 0">
                            R$ {{ item.preco.toFixed(2).replace(".", ",") }}
                        </p>
                        <p v-if="promocaoMenorQueValorNormal"  style="font-weight: bolder; margin: 0">
                            R$ {{ item.promocao.toFixed(2).replace(".", ",") }}
                        </p>
                        <p v-if="!promocaoMenorQueValorNormal" style="margin: 0">
                            R$ {{ item.promocao.toFixed(2).replace(".", ",") }}
                        </p>
                    </div>
                </div>

                <!-- o combo por tamanho, comboPorEtapa e comboPizza nao tem preco especifico, depende dos itens dentro dele que o cliente escolher -->
                <div v-if="item.tipo == 'comboPorTamanho' || item.tipo == 'comboPorEtapa' || item.tipo == 'comboPizza'" class="titulo-preco-preco">
                    <!-- preco normal  -->
                    <span>A partir de</span>
                    <p v-if="item.tipo == 'comboPorTamanho'" >R$ {{ precoComboTamanho }}</p>
                    <p v-if="item.tipo == 'comboPorEtapa'" >R$ {{ precoComboEtapa }}</p>
                    <p v-if="item.tipo == 'comboPizza'" >R$ {{ precoComboPizza }}</p>
                </div>

            </div>

            <!-- descricao do item ( paenas hrc) -->
            <div v-if="isHardRock && item.descricao != null && item.descricao.trim().length > 0" style="margin: 0px; margin-top: 0px;">
                <p style="text-align: justify; margin: 0; padding: 0;">{{ item.descricao }}</p>
            </div>
            
            
        </div>


    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
/**
 * Mostra o card de cada item
 * @vue-data {Boolean} precoVaria - verifica se o preco pode mudar
 * @vue-data {string} altImg - imagem para ser usada caso o cliente nao tenha imagem
 * @vue-prop {object} item - é o item inteiro dentro da lista itensVenda do store
 * @vue-computed {Array} itensVenda é o que vem do store e tem todos os itens da classe selecionada
 */
export default {
    nome: "CadaItemVenda",
    props: {
        item: Object,
        
    },
    computed: {
        ...mapState(["itensVenda"]),
        temPromocao() {
            if (this.item.promocao != null) {
                return true;
            }
            return false;
        },
        promocaoMenorQueValorNormal() {
            if(this.item.promocao != null && parseFloat(this.item.promocao) < parseFloat(this.item.preco)) {
                return true;
            }
            return false;
        },

        precoComboTamanho() {
            let menorPreco = 150000
            if (this.item.subitens != null) {
                for (var i = 0; i < this.item.subitens.length; i++) {
                    const elem = this.item.subitens[i].valorVenda
                    if (elem < menorPreco) {
                        menorPreco = elem
                    }
                }
            }
            return  menorPreco.toFixed(2).replace(".", ",")
        },

        precoComboEtapa() {
            return  this.item.preco.toFixed(2).replace(".", ",")
        },

        precoComboPizza() {
            return  this.item.preco.toFixed(2).replace(".", ",")
        },

        porColunas() {
            return this.$store.state.organizarPorColunas
        }
        
    },
    created() {
        this.adicionarSimboloMais();
    },

    data() {
        return {
            precoVaria: "",
            classe: "container",
            altImg: "../../assets/ham.png",
            temImagem: true,
            isHardRock: this.$store.state.isHardRock,
        };
    },
    methods: {
        /**
         * se o preco for variavel, vai adicionar um '+' no preco para o usuario saber que o preco pode ser maior
         */
        adicionarSimboloMais() {
            let precoVariavel = this.item["preco"] == null ? true : false;
            if (precoVariavel) {
                this.precoVaria = "+";
            } else {
                this.precoVaria = "";
            }
        },

        /**
         * caso a url da imagem nao esteja funcionando, deve entao usar  a fallback image i-c-camera.png dos assets
         */
        onErrorImagem() {
            this.temImagem = false;
            // this.$refs.imagemzinha.src = require(`../../assets/icons/ic-camera.png`);
        },

        /**
         * Abre a tela do item clicado.
         * Adiciona o item no store, na var setItemSelecionado para depois poder ser lido da store.
         * vai para a classe views/CadaItemView
         *
         * @see CadaItemView
         */
        abriuItemVenda() {
            console.log('Abriu esse item:')
            console.log(this.item)
            this.$store.dispatch("setItemSelecionado", this.item);
            if (this.$store.state.isMenuEstatico) {
                this.$router.push({
                    name: "menu-estatico-item",
                    params: {
                        item: this.item,
                        id: this.id,
                    },
                });
            } else {
                this.$router.push({
                    name: "item",
                    params: {
                        item: this.item,
                        id: this.id,
                        atributoAnteriorCasoItemEditado: null,
                    },
                });
            }
        },

        /**
         * adicionar o id do item junto com o preco e o nome para confirmacao no final da compra
         */
        clicouItemVenda() {
            this.$store.state.itensCarrinho.push({
                id: this.id,
            });
        },
        ...mapActions({
            setItensCarrinho: "setItensCarrinho",
        }),
    },
};
</script>

<style scoped>

.container {
    display: block;
    align-items: center;
    border-radius: 5px;
    background: white;
    animation: container 0.6s forwards;
    height: 100%;
    margin: 0px;
}

@keyframes container {
    from {opacity: 0.0; scale: 0.9};
    to {opacity: 1; scale: 1.0}
}

.imagens {
    /* height: 140px; */
    width: 100%;
    margin: 0;
    padding: 0;
    margin-bottom: -5px;

    /* antes era 210/140 que eh a resolucao da imagem mesmo; */
    aspect-ratio: 210 / 100;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    object-position: 0% 50%;
    object-fit: cover;
}



.titulo-preco {
    display: flex;
    /* justify-content: space-between; */
    text-align: center;
    margin: 0;
    height: fit-content;
    padding-inline: 10px;
    max-width: 100%;
    align-items: center;

}
.titulo-preco-block {
    display: block;
    padding: 10px;
    height: 80px;
}

.titulo-preco-nome {
    margin: 0;
    padding: 0;
    color: var(--primaryDark_azul);
    text-align: left;
    flex: 2 1 10px; 
    font-size: 15px;
    font-weight: 900;
    
}

.titulo-preco-preco {
    margin: 0;
    padding: 0;
    color: green;
    text-align: right;
    flex: 1 1 10px; 
    font-size: 15px;
    font-weight: 900;
}

.titulo-preco-preco > span {font-size: 0.7rem; font-weight: 500;}
</style>